import React from "react";
import { FileText, Layers } from "lucide-react";
import { PageHeader, card } from "./AdminShell";

/* Placeholder pages - kept in menu structure per plan */
export function AdminArticles() {
  return (
    <div>
      <PageHeader title="Articles" subtitle="Publikasi artikel edukasi & konten SEO" />
      <div className={`${card} p-10 text-center`}>
        <FileText size={40} className="mx-auto text-neutral-300 mb-3" />
        <h2 className="font-display font-bold text-neutral-900 text-lg mb-2">Segera Hadir</h2>
        <p className="text-sm text-neutral-500 max-w-md mx-auto">
          Editor artikel penuh sedang dalam pengembangan. Arsitektur navigasi & routing sudah disiapkan
          untuk kategori: Kompresor, Mesin Konstruksi, Maintenance, Spare Parts, Tips Mesin, Informasi Produk.
        </p>
      </div>
    </div>
  );
}

export function AdminPagesCms() {
  return (
    <div>
      <PageHeader title="Pages" subtitle="Kelola halaman statis (About, Privacy, Terms, dll)" />
      <div className={`${card} p-10 text-center`}>
        <Layers size={40} className="mx-auto text-neutral-300 mb-3" />
        <h2 className="font-display font-bold text-neutral-900 text-lg mb-2">Segera Hadir</h2>
        <p className="text-sm text-neutral-500 max-w-md mx-auto">
          Sistem halaman statis akan memungkinkan pengelolaan konten About Us, Privacy Policy, Terms & Conditions
          langsung dari admin tanpa mengedit kode.
        </p>
      </div>
    </div>
  );
}
